import {useMemo} from "react";
import {fetchProduct} from "../infrastructure/productApi";
import {useRemoteData} from "../../common/utils/useRemoteData";
import { useComercialContext } from "../../comercial/ComercialContext";

export const useProduct = (productCode) => {
    const { actingAsCliente } = useComercialContext();
    const actingAsNumCliente = actingAsCliente?.numCliente ?? null;

    const fetchProductFn = useMemo(
        () => (() => fetchProduct(productCode, actingAsNumCliente)),
        [productCode, actingAsNumCliente]
    );

    const productRemoteData = useRemoteData(
        {
            initial: null,
            dataFetchingCallback: fetchProductFn
        });

    return {productRemoteData};
};
